import Vue from 'vue';
import Router from 'vue-router';
import Atms from './views/atms/Atms.vue';
import Worklogs from './views/worklogs/Worklogs.vue';
import NewWorker from './views/worklogs/NewWorker.vue';
import NewWorklog from './views/worklogs/NewWorklog.vue';
import EditWorklog from './views/worklogs/EditWorklog.vue';
import LoginCallback from './components/LoginCallback.vue';
import { authService } from '@/services/AuthenticationService';

Vue.use(Router);

export enum Paths {
  HOME = 'HOME',
  WORK_LOGS = 'WORK_LOGS',
  TRAVEL_LOGS = 'TRAVEL_LOGS',
  ATMS = 'ATMS',
  NEW_ATM = 'NEW_ATM',
  AUTH_CALLBACK = 'AUTH_CALLBACK',
  NEW_WORKER = 'NEW_WORKER',
  NEW_WORKLOG = 'NEW_WORKLOG',
  EDIT_WORKLOG = 'EDIT_WORKLOG',
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: Paths.HOME,
      redirect: { name: Paths.WORK_LOGS },
    },
    {
      path: '/atms',
      name: Paths.ATMS,
      component: Atms,
      beforeEnter: (to, from, next) => {
        if (authService.authenticationDetails() !== null) {
          next();
        } else {
          authService.login();
        }
      },
    },
    {
      path: '/work-logs',
      name: Paths.WORK_LOGS,
      component: Worklogs,
      beforeEnter: (to, from, next) => {
        if (authService.authenticationDetails() !== null) {
          next();
        } else {
          authService.login();
        }
      },
    },
    {
      path: '/new-worker',
      name: Paths.NEW_WORKER,
      component: NewWorker,
      beforeEnter: (to, from, next) => {
        if (authService.authenticationDetails() !== null) {
          next();
        } else {
          authService.login();
        }
      },
    },
    {
      path: '/new-worklog',
      name: Paths.NEW_WORKLOG,
      component: NewWorklog,
      beforeEnter: (to, from, next) => {
        if (authService.authenticationDetails() !== null) {
          next();
        } else {
          authService.login();
        }
      },
    },
    {
      path: '/edit-worklog/:worklogId',
      name: Paths.EDIT_WORKLOG,
      component: EditWorklog,
      beforeEnter: (to, from, next) => {
        if (authService.authenticationDetails() !== null) {
          next();
        } else {
          authService.login();
        }
      },
    },
    {
      path: '/auth-callback',
      name: Paths.AUTH_CALLBACK,
      component: LoginCallback,
    },
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
    // },
  ],
});
